import React from 'react';

import { useGlobal } from '../../../contexts/Global/context';

import GenericCard from './GenericCard';

import dataCards from './dataCards';

import { PageContainer } from '../../../styles/styles';

import * as S from './styles';

function MateriaisApoio() {
    const {
        dataActiveContract: { isPme },
    } = useGlobal();

    return (
        <PageContainer>
            <S.ContainerCards>
                {dataCards.map(
                    ({ cardPme, ...cardProps }) => ((cardPme && isPme) || !cardPme) && <GenericCard {...cardProps} />
                )}
            </S.ContainerCards>
        </PageContainer>
    );
}

export default MateriaisApoio;
